<ngx-loading-bar></ngx-loading-bar>
<router-outlet></router-outlet>
<app-tap-to-top></app-tap-to-top>
<app-layout-box></app-layout-box>